<template>
  <md-field>
    <md-select v-model="_value">
      <md-option v-for="h in hours" :key="h.value" :value="h.value">{{
        h.text
      }}</md-option>
    </md-select>
  </md-field>
</template>
<script>
/**
 * 時間帯選択ドロップダウン
 * 指定された開始～終了まで時間帯を作成します。
 */
export default {
  props: {
    /**
     * この時間からリストを作成する８
     */
    min: {
      type: Number,
      default: 0,
    },
    /**
     * この時間までリストを作成する
     */
    max: {
      type: Number,
      default: 23,
    },
    /**
     * 選択されている時間
     */
    value: {
      type: Number,
    },
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value)
      },
    },
    hours() {
      const hours = []

      for (let i = this.min; i <= this.max; i++) {
        hours.push({
          value: i,
          text: i + '時台',
        })
      }
      return hours
    },
  },
}
</script>
